module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATJJREFUeNrsmdENgjAQhtE4ACMwAk4gboBvJj4gExgmQCfQEfDBxDcZwQ1kBNyAEbxL+mBIqzVKeuD/J80lhYT72uv1WjwPgqBXGpkelOdTSMaX5nC8XF2tQQhiSyYXOvgVwUzbnWPDy7ngKAppoCNbkN4JIADpSBOH3+Y0emRLWajWZM6YzEU6SEbOH96800ifkZQgir6vkbILCBcguyEs9oZmozKURAGZDe/aT92+VBATBDt8+7ZAlbCP/KTKxs4OEIC4yVqFqqNsSg7OZnNNf0Jt7Rrkbjpba87gjSog22k5GkpozbDYhan/oaXKFhFZKyFn2jHO91GZxmkuUfatbjEggWo28j8NIyx2gAAEIAABCEAAAhAZILVwv2tbkIXuHC1AfFGR6n4MQRD0J3oIMAB8XkDnPggAMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_fb.png
// module id = 920
// module chunks = 114276838955818